var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProductions = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 0.903,
  d: "M9.776 1.88a3.01 3.01 0 0 1 0 4.256M8.358 3.3a1.003 1.003 0 0 1 0 1.419"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.183 8.636c.532 0 1.064-.267 1.302-.72h.024v.218c.023.343.242.518.555.518.33 0 .564-.2.564-.585v-2.43c0-.86-.71-1.424-1.802-1.424-.881 0-1.564.314-1.762.823a.6.6 0 0 0-.06.263c0 .262.203.445.485.445a.58.58 0 0 0 .46-.215c.258-.334.472-.45.825-.45.437 0 .715.232.715.63v.282l-1.072.063c-1.063.064-1.659.513-1.659 1.289 0 .768.615 1.293 1.425 1.293m.381-.84c-.389 0-.65-.198-.65-.517 0-.302.245-.497.678-.529l.897-.055v.31c0 .461-.417.791-.925.791"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 0.903,
  d: "M6.02 2.006H3.31c-.996 0-1.805.808-1.805 1.805v4.414c0 .997.809 1.805 1.806 1.805h5.417c.997 0 1.805-.808 1.805-1.805v-.2"
})));
export default SvgProductions;